import { HeatingCircuit } from 'z3k-config';
import { getZ3kEntityById } from 'z3k-parser/lib/auxiliary';
import { getTemperature, getTemperatureRange, } from 'console/shared/utils/temp';
import { existSensor } from 'shared/utils/exist_sensor';
/**
 * @function
 * Узнаю диапазон температур для контура.
 * Нахожу из состояния датчик по которому осуществляется управление
 * https://git.microline.ru/zont/server/-/issues/1302
 * @param hc - кусочек контура, в котором есть необходимые параметры
 * @param hc_state - состояние контура
 * @param z3k_config - конфиг устройства
 * @return диапазон {min, max}
 */
export function getControlTempRange(hc, hc_state, z3k_config) {
    //для контура потребителя
    if (HeatingCircuit.isConsumer(hc)) {
        const consumer_mode = HeatingCircuit.getConsumerMode(hc);
        switch (consumer_mode) {
            case HeatingCircuit.ConsumerMode.AIR:
            case HeatingCircuit.ConsumerMode.AIR_PID: {
                if (hc_state && z3k_config) {
                    const sensor_id = hc_state.target_sensor_id;
                    if (sensor_id) {
                        const [obj_ns, sensor] = getZ3kEntityById(z3k_config, sensor_id);
                        if (sensor) {
                            const _sensor = existSensor(obj_ns, sensor);
                            if (_sensor) {
                                return getTemperatureRange(_sensor.lower_threshold, _sensor.upper_threshold, 5, 40);
                            }
                        }
                    }
                }
                break;
            }
            case HeatingCircuit.ConsumerMode.WATER: {
                //по теплоносителю + ПЗА
                if (HeatingCircuit.isAirIndication(hc)) {
                    return { min_temperature: 5, max_temperature: 35 };
                }
                const { water_min_temperature, water_max_temperature } = hc;
                if (hc_state && !HeatingCircuit.isAirIndication(hc)) {
                    const sensor_id = hc_state.target_sensor_id;
                    if (sensor_id && z3k_config) {
                        const [obj_ns, sensor] = getZ3kEntityById(z3k_config, sensor_id);
                        if (sensor) {
                            const _sensor = existSensor(obj_ns, sensor);
                            if (_sensor) {
                                return getTemperatureRange(water_min_temperature, water_max_temperature, getTemperature(_sensor.lower_threshold, 0), getTemperature(_sensor.upper_threshold, 100));
                            }
                        }
                    }
                }
                //по теплоносителю + ПЗА
                if (HeatingCircuit.isAirIndication(hc)) {
                    return getTemperatureRange(5, water_max_temperature, 5, 35);
                }
                return getTemperatureRange(water_min_temperature, water_max_temperature, -30, 100);
            }
        }
        return { min_temperature: -30, max_temperature: 100 };
    }
    if (HeatingCircuit.isDHW(hc)) {
        //для ГОРЯЧЕГО водоснабжения не нужны отрицательные температуры
        //у большинства производителей ограничение по бочке 60 градусов
        return { min_temperature: 5, max_temperature: 75 };
    }
    if (HeatingCircuit.isCooling(hc)) {
        if (hc_state && z3k_config) {
            const sensor_id = hc_state.target_sensor_id;
            if (sensor_id) {
                const [obj_ns, sensor] = getZ3kEntityById(z3k_config, sensor_id);
                if (sensor) {
                    const _sensor = existSensor(obj_ns, sensor);
                    if (_sensor) {
                        return getTemperatureRange(_sensor.lower_threshold, _sensor.upper_threshold, 0, 80);
                    }
                }
            }
        }
        return { min_temperature: 0, max_temperature: 80 };
    }
    return { min_temperature: 0, max_temperature: 30 };
}
